export interface INIAnalytics {
  captureVirtualPageLoad(data: any): void;

  captureResultClick(data: any): void;

  captureSearchFilter(data: any): void;

  captureSearchSubmit(data: any): void;

  captureSearchInstead(data: any): void;

  setAndTrack(key: string, value: string): void;

  sendBeacon(data: any): void;

  getDataElement(name: string): string;
}

declare var NIAnalytics: INIAnalytics;

export class NIAnalyticsWrapper implements INIAnalytics {

  constructor() {
  }

  captureResultClick(data: any): void {
    try {
      if (typeof NIAnalytics !== "undefined" && typeof NIAnalytics.captureResultClick === "function") {
        NIAnalytics.captureResultClick(data);
      }
    } catch (e) {
      console.log(e);
    }
  }

  captureSearchFilter(data: any): void {
    try {
      if (typeof NIAnalytics !== "undefined" && typeof NIAnalytics.captureSearchFilter === "function") {
        NIAnalytics.captureSearchFilter(data);
      }
    } catch (e) {
      console.log(e);
    }
  }

  captureSearchInstead(data: any): void {
    try {
      if (typeof NIAnalytics !== "undefined" && typeof NIAnalytics.captureSearchInstead === "function") {
        NIAnalytics.captureSearchInstead(data);
      }
    } catch (e) {
      console.log(e);
    }
  }

  captureSearchSubmit(data: any): void {
    try {
      if (typeof NIAnalytics !== "undefined" && typeof NIAnalytics.captureSearchSubmit === "function") {
        NIAnalytics.captureSearchSubmit(data);
      }
    } catch (e) {
      console.log(e);
    }
  }

  captureVirtualPageLoad(data: any): void {
    try {
      if (typeof NIAnalytics !== "undefined" && typeof NIAnalytics.captureVirtualPageLoad === "function") {
        NIAnalytics.captureVirtualPageLoad(data);
      }
    } catch (e) {
      console.log(e);
    }
  }

  setAndTrack(key: string, value: string): void {
    try {
      if (typeof NIAnalytics !== "undefined" && typeof NIAnalytics.setAndTrack === "function") {
        NIAnalytics.setAndTrack(key, value);
      }
    } catch (e) {
      console.log(e);
    }
  }

  sendBeacon(data: any): void {
    try {
      if (typeof NIAnalytics !== "undefined" && typeof NIAnalytics.sendBeacon === "function") {
        NIAnalytics.sendBeacon(data);
      }
    } catch (e) {
      console.log(e);
    }
  }

  getDataElement(name: string): string {
    try {
      if (typeof NIAnalytics !== "undefined" && typeof NIAnalytics.getDataElement === "function") {
        return NIAnalytics.getDataElement(name);
      }
    } catch (e) {
      console.log(e);
    }

    return "N/A";
  }

}
